// This function allow to reference chunks
__webpack_require__.k = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/main/web/6078/css/" + chunkId + "." + __webpack_require__.h().slice(0, 8) + ".css"
}